// extracted by mini-css-extract-plugin
export default {"timerTitle":"Timer_timerTitle__F3LIM","time":"Timer_time__8rnvG"};